import React from "react";

export const useInitializeReservationSelection = ({
	isReservationMode,
	ids,
	data,
	replaceSelectedPalletsUI,
}) => {
	React.useEffect(() => {
		if (!isReservationMode || !ids?.length || !data) return;

		const palletDict = {};

		ids.forEach((id) => {
			const pallet = data[id];
			palletDict[pallet.id] = !!pallet?.reserved_order_id;
		});

		// Merge instead of replace: only seed entries for pallets we haven't seen yet.
		// Existing entries reflect the user's explicit selections on other pages and must survive
		// pagination/filter changes until the reservation is submitted.
		replaceSelectedPalletsUI((prev) => ({ ...palletDict, ...prev }));
	}, [isReservationMode, ids, data, replaceSelectedPalletsUI]);
};
